module.exports = __webpack_public_path__ + "static/media/for_parents.57b4e783.png";